<mat-toolbar class="header-container mat-elevation-z2">
  <h1 fxHide.xs>{{ title }}</h1>
  <div fxFlex></div>

  <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="0.25rem">
    <!-- LANGUAGE -->
    <app-language-selector icon="true"></app-language-selector>
  </div>
</mat-toolbar>
